import urlcat from 'urlcat';
import { defaultAxiosInstance as Client } from '@/api/defaultConfiguration';

export default class BaseRepository {
	constructor(defaultParams = {}) {
		this.defaultParams = defaultParams;
	}

	get endpoint() {
		return 'api';
	}

	makeResource(resource, params) {
		if (params && Object.keys(params).length) {
			return urlcat(resource, params, { arrayFormat: 'brackets' });
		}

		return resource;
	}

	makeUrl(subResource, params) {
		return this.makeResource([this.endpoint, subResource].filter(x => x).join('/'), { ...this.defaultParams, ...params });
	}

	index(params) {
		return this.get('', params);
	}

	store(data, params) {
		return this.post('', params, data);
	}

	show(id, params) {
		return this.get(`${id}`, params);
	}

	update(id, data, params = {}) {
		return this.put(`${id}`, params, data);
	}

	destroy(id, params) {
		return this.delete(`/${id}`, params);
	}

	get(resource, params, config = {}) {
		return Client.get(this.makeUrl(resource, params), config);
	}

	put(resource, params, data) {
		return Client.put(this.makeUrl(resource, params), data);
	}

	post(resource, params, data, config = {}) {
		return Client.post(this.makeUrl(resource, params), data, config);
	}

	delete(resource, params) {
		return Client.delete(this.makeUrl(resource, params));
	}
}
